import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

import { Theme, Target } from 'mewe/constants';
import { openPostbox } from 'mewe/utils/dialogs-common';

export default class MwPostboxPlaceholder extends Component {
  @service account;
  @service dynamicDialogs;

  get groupIdOrEventGroupId() {
    return this.args.targetId || this.args.eventState?.rootEvent?.groupId;
  }

  get postboxPlaceholder() {
    const theme = this.args.theme;

    if (theme === 'event') {
      return __('Post to this event');
    } else if (theme === 'group') {
      return __('Post to this group');
    } else if (theme === 'groups') {
      return __('Share something with one of your groups');
    } else if (theme === 'mycloud') {
      return __('Add photos and files to My Cloud');
    } else if (theme == 'page') {
      return __('Share a post with your followers');
    } else {
      return __('How is your day going?');
    }
  }

  get avatarUrl() {
    if (!this.args.page) return ''; // page is passed direct

    // might be not present yet on first load after login
    if (this.account.activeUser._links?.avatar?.href) {
      let userAvatar =
        this.account.activeUser._links.avatar.href.replace('{imageSize}', '150x150');
      return this.groupIdOrEventGroupId
        ? userAvatar + `&group=${this.groupIdOrEventGroupId}&f=${this.account.activeUser.fprint}`
        : userAvatar;
    }
  }

  get target() {
    if (typeof this._target !== 'undefined') {
      return this._target;
    }

    switch (this.args.theme) {
      case Theme.PROFILE:
      case Theme.CONTACTS:
        return Target.CONTACTS;

      case Theme.EVENT:
      case Theme.EVENTS:
        return Target.EVENT;

      case Theme.GROUP:
      case Theme.GROUPS:
        return Target.GROUP;

      case Theme.PAGES:
      case Theme.PAGE:
        return Target.PAGE;

      default:
        return '';
    }
  }

  @action
  openPostbox(e) {
    openPostbox(
      {
        target: this.target,
        targetId: this.args.targetId,
        theme: this.args.theme,
        groupId: this.args.theme === Theme.EVENT ? '' : this.groupId, // in case of group event don't send groupId SG-22656
        page: this.args.page,
        eventState: this.args.eventState,
        preselectedGroup: this.args.preselectedGroup,
        preselectedEvent: this.args.preselectedEvent,
      },
      this.dynamicDialogs
    );
  }
}
